export default {
  setServiceOrderList(state, serviceOrderList) {
    state.serviceOrderList = serviceOrderList
  },
  setServiceLogList(state, serviceLogList) {
    state.serviceLogList = serviceLogList
  },
  setServiceConfigObj(state, serviceConfigObj) {
    state.serviceConfigObj = serviceConfigObj
  },
  setServiceLogDetail(state, serviceLogDetail) {
    state.serviceLogDetail = serviceLogDetail
  }
}
